import { combineReducers } from "redux";
import authReducer from "./authReducer";
import routeReducer from "./routeReducer";
import commonReducer from "./commonReducer";
import rolePermissionReducer from "./rolePermissionReducer";
import billReducer from "./billReducer";
import communicationReducer from "./communicationReducer";
import profileReducer from "./profileReducer";
import adminReducer from "./adminReducer";
import manageDataReducer from "./manageDataReducer";
import dtReducer from "./dtReducer";
import validationReducer from "./validationReducer";
import deedReducer from "./deedReducer";
import tempUploadReducer from "./tempUploadReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  route: routeReducer,
  common: commonReducer,
  rolePermission: rolePermissionReducer,
  bill: billReducer,
  communication: communicationReducer,
  profile: profileReducer,
  admin: adminReducer,
  manageData: manageDataReducer,
  dt: dtReducer,
  validation: validationReducer,
  deed: deedReducer,
  temp: tempUploadReducer,
});

export default rootReducer;
